import { render, staticRenderFns } from "./addModal.vue?vue&type=template&id=6b2f5a89&scoped=true"
import script from "./addModal.vue?vue&type=script&lang=js"
export * from "./addModal.vue?vue&type=script&lang=js"
import style0 from "./addModal.vue?vue&type=style&index=0&id=6b2f5a89&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2f5a89",
  null
  
)

export default component.exports